import type { TypographyProps } from '@mui/material/Typography';
import type { ReactNode } from 'react';

import {
  BLOCK_COMPONENTS,
  DEFAULT_BLOCK_VARIANTS,
  type RichTextBlockKey,
  type RichTextBlockPropsMap,
  type RichTextTypographyBlockKey,
  type RichTextTypographyBlockProps,
} from './types';

export function renderTextWithLineBreaks(text: string): ReactNode {
  const lines = text.split('\n');
  if (lines.length === 1) {
    return text;
  }

  const nodes: ReactNode[] = [lines[0]];
  for (let i = 1; i < lines.length; i++) {
    nodes.push(<br key={i} />);
    nodes.push(lines[i]);
  }
  return nodes;
}

export function resolveTypographyBlockProps(
  key: RichTextTypographyBlockKey,
  cx: (...classes: Array<string | false | undefined>) => string,
  options?: {
    variants?: Partial<
      Record<RichTextTypographyBlockKey, TypographyProps['variant']>
    >;
    blockProps?: RichTextBlockPropsMap;
    blockClasses?: Partial<Record<RichTextBlockKey, string>>;
    extraProps?: RichTextTypographyBlockProps;
  }
): RichTextTypographyBlockProps {
  const blockProps = options?.blockProps?.[key];
  const variant =
    blockProps?.variant ??
    options?.variants?.[key] ??
    DEFAULT_BLOCK_VARIANTS[key];

  return {
    component: BLOCK_COMPONENTS[key],
    ...options?.extraProps,
    ...blockProps,
    variant,
    className: cx(
      options?.blockClasses?.[key],
      options?.extraProps?.className,
      blockProps?.className
    ),
  };
}
